// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewPagoCobro = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'pago_cobro',
        name: 'Pago y Cobranza',
        component: ViewPagoCobro,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
